var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1064_1287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1064_1287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.025 21.5V19.35C10.1417 19.15 9.37918 18.7667 8.73751 18.2C8.09585 17.6333 7.62501 16.8333 7.32501 15.8L9.17501 15.05C9.42501 15.85 9.79585 16.4583 10.2875 16.875C10.7792 17.2917 11.425 17.5 12.225 17.5C12.9083 17.5 13.4875 17.3458 13.9625 17.0375C14.4375 16.7292 14.675 16.25 14.675 15.6C14.675 15.0167 14.4917 14.5542 14.125 14.2125C13.7583 13.8708 12.9083 13.4833 11.575 13.05C10.1417 12.6 9.15835 12.0625 8.62501 11.4375C8.09168 10.8125 7.82501 10.05 7.82501 9.15C7.82501 8.06667 8.17501 7.225 8.87501 6.625C9.57501 6.025 10.2917 5.68333 11.025 5.6V3.5H13.025V5.6C13.8583 5.73333 14.5458 6.0375 15.0875 6.5125C15.6292 6.9875 16.025 7.56667 16.275 8.25L14.425 9.05C14.225 8.51667 13.9417 8.11667 13.575 7.85C13.2083 7.58333 12.7083 7.45 12.075 7.45C11.3417 7.45 10.7833 7.6125 10.4 7.9375C10.0167 8.2625 9.82501 8.66667 9.82501 9.15C9.82501 9.7 10.075 10.1333 10.575 10.45C11.075 10.7667 11.9417 11.1 13.175 11.45C14.325 11.7833 15.1958 12.3125 15.7875 13.0375C16.3792 13.7625 16.675 14.6 16.675 15.55C16.675 16.7333 16.325 17.6333 15.625 18.25C14.925 18.8667 14.0583 19.25 13.025 19.4V21.5H11.025Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollor);
export default __webpack_public_path__ + "static/media/Dollor.2ff001e0a55b07c4782f529a72cd887c.svg";
export { ForwardRef as ReactComponent };